
import React from 'react';
import { QuickscanProvider } from '@/contexts/QuickscanContext';
import { QuickscanFlow } from './QuickscanFlow';

export const QuickscanContainer = () => {
  return (
    <QuickscanProvider>
      <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-energy-green/10">
        <QuickscanFlow />
      </div>
    </QuickscanProvider>
  );
};
